/** Stub: Xリワード */
export class SocialRewardAdapter {
  openFollowUrl(): void {
    window.open("https://x.com/intent/follow?screen_name=PLACEHOLDER", "_blank");
  }

  openRepostUrl(text: string, url: string): void {
    const encoded = encodeURIComponent(`${text} ${url}`);
    window.open(`https://x.com/intent/tweet?text=${encoded}`, "_blank");
  }
}
